import React, { memo, useEffect, useState } from 'react'
import { SortableContext } from "@dnd-kit/sortable";
import { useDroppable } from "@dnd-kit/core";
import { Product } from './Product.js'

export const DnDContainer = memo(function DnDContainer(props) {
  const { items, containerType } = props;
  const [products, setProducts] = useState(items);

  useEffect(() => {
    setProducts(items)
  }, [items]);

  // Only profile items and trash should be droppable
  const { isOver, setNodeRef } = containerType == "profile"
      ? useDroppable({ id: containerType })
    : { 
        isOver: false, 
        setNodeRef: () => {} 
      };

  //console.log(containerType + " product list:", products);

  return (
    <SortableContext id={containerType} items={items}>
      <div ref={setNodeRef} className={"profmaintContainer" + (isOver ? ' over' : '')}>
        {products.map((item) => (
          <Product
            key={item.id}
            id={`${item.id}`}
            source={item.source}
            text={item.text}
          />
        ))}
      </div>
    </SortableContext>
  )
});